import styled from 'styled-components';

export const StyledRateWrapper = styled.div`
  .ant-rate {
    font-size: 14px;
  }
  .ant-rate,
  .ant-rate-star-full .ant-rate-star-second {
    color: ${({ theme }) => theme.colors.tone.yellow};
  }
  .ant-rate-star-second {
    color: ${({ theme }) => theme.colors.grayVariations.murky};
  }
`;
